import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../lib/seo';
import { fetchCmsList } from '../lib/cms';

export function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    async function load() {
      const data = await fetchCmsList('services');
      if (data.length) setServices(data);
    }
    load();
  }, []);

  return (
    <>
      <SEO 
        title="Ydelser & Behandlinger | Fodtid"
        description="Oversigt over professionelle fodbehandlinger i eget hjem: Komplet fodbehandling, Fodpleje abonnement til 119 kr./mdr., laserbehandling og naturlig fodpleje."
      />

      {/* Header */}
      <section className="bg-canvas py-14 sm:py-18 border-b border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 text-center space-y-3">
          <span className="text-xs uppercase font-bold tracking-widest text-brand-charcoal bg-surface px-3.5 py-1 rounded-full border border-brand-border">
            Klinisk Fodpleje i Hjemmet
          </span>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-brand-charcoal">
            Ydelser & Behandlinger
          </h1>
          <p className="text-brand-muted text-sm sm:text-base max-w-xl mx-auto leading-relaxed">
            Vi tilbyder et bredt spektrum af specialiserede behandlinger tilpasset dine fødders behov – altid udført med ro, faglighed og personlig omsorg i dit eget hjem.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16 sm:py-24 bg-canvas border-b border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((svc) => (
              <div
                key={svc.id || svc.slug}
                className="bg-surface/50 rounded-3xl p-8 border border-brand-border flex flex-col justify-between hover:shadow-md transition-all group"
              >
                <div className="space-y-6">
                  {svc.image?.[0] && (
                    <div className="aspect-16/9 rounded-2xl overflow-hidden bg-surface relative">
                      <img
                        src={`https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/${svc.image[0].replace('https://assets.auxodev.dk/', '')}`}
                        alt={svc.title}
                        className="w-full h-full object-cover group-hover:scale-103 transition-transform duration-300"
                        loading="lazy"
                      />
                      {svc.price && (
                        <div className="absolute top-4 right-4 bg-brand-charcoal text-canvas font-bold text-xs px-3.5 py-1.5 rounded-full shadow">
                          {svc.price}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="space-y-3">
                    <h2 className="font-serif text-2xl font-bold text-brand-charcoal group-hover:text-brand-accent transition-colors">
                      {svc.title}
                    </h2>
                    <p className="text-sm text-brand-muted leading-relaxed">
                      {svc.short_description}
                    </p>
                  </div>
                </div>

                <div className="pt-8 mt-6 border-t border-brand-border flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                  <Link
                    to={`/ydelser/${svc.slug?.da || svc.slug || (svc.title === 'Komplet Fodbehandling' ? 'komplet-fodbehandling' : svc.title.toLowerCase().replace(/\s+/g, '-'))}`}
                    className="inline-flex items-center justify-center gap-2 bg-[#A67C3D] hover:bg-[#91692E] text-white font-bold px-6 py-3 rounded-full text-xs uppercase tracking-wider shadow-sm transition-all"
                  >
                    <span>Læs mere om behandlingen</span>
                    <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                  </Link>

                  <Link
                    to="/kontakt"
                    className="inline-flex items-center justify-center gap-2 bg-white hover:bg-stone-50 text-stone-900 border border-stone-300 font-bold px-5 py-3 rounded-full text-xs uppercase tracking-wider transition-colors"
                  >
                    <i className="fa-solid fa-calendar-check text-[#A67C3D]" aria-hidden="true" />
                    <span>Bestil tid</span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
